export default __webpack_public_path__ + "static/media/keyvis_gold_band@2x.cc37eb1b.png";